import analyticsQueryString from '@component/common/src/util/AnalyticsQueryString';

const COREID6_COUNT = 5;
const ProsTrackingHelper = {
  getCmCoreId6() {
    const validCoreId = new Promise((resolve) => {
      let coreId;
      let count = 0;

      const pollingCoreId = setInterval(() => {
        coreId = this.pollCoreId();
        // check session storage for coreId
        if (coreId && coreId !== 'undefined') {
          clearInterval(pollingCoreId);
          resolve(coreId);
        } else if (count >= COREID6_COUNT) {
          clearInterval(pollingCoreId);
          resolve();
        }

        count += 1;
      }, 1000);
    });

    return validCoreId;
  },
  pollCoreId() {
    return sessionStorage.getItem('cmCoreId6');
  },
  getCMParamter(paramName, queryString) {
    let paramValue = analyticsQueryString.getTrackingValue(`cm_${paramName}`, queryString);
    paramValue = paramValue || analyticsQueryString.getTrackingValue(paramName, queryString);
    return paramValue;
  },
  getTDPParameter(queryString) {
    return analyticsQueryString.getTrackingValue('tdp', queryString);
  },
  getCGIDParamter(queryString, argChoiceId) {
    let choiceId = argChoiceId;
    if (!choiceId) {
      choiceId = this.getCMParamter('choiceId', queryString);
    }
    let cgId;

    if (choiceId && choiceId.split('-') && choiceId.split('-').length) {
      const [controlGroupId] = choiceId.split('-');
      cgId = controlGroupId.substring(3, 9);
    }
    return (cgId) || '';
  },
  getBatchId(queryString, argChoiceId) {
    let dId;
    let choiceId = argChoiceId;
    if (!choiceId) {
      choiceId = this.getCMParamter('choiceId', queryString);
    }
    if (choiceId) {
      dId = choiceId.match((/-([\w\d-]+)/));
    }

    return (dId && dId[1]) ? dId[1] : '';
  },
  getHeaderId(queryString, argChoiceId) {
    let hId;
    let choiceId = argChoiceId;
    if (!choiceId) {
      choiceId = this.getCMParamter('choiceId', queryString);
    }
    if (choiceId) {
      hId = choiceId.match(/@(H.+?)@/);
    }

    return (hId && hId.length) ? hId[1] : '';
  },

  generateTdpQueryParam({
    requester, zone, thumb,
  }) {
    const aRequester = `cm_app~z${requester}~`;
    const aZone = `xcm_zone~z${zone}~`;
    const qChoiceId = `xcm_choiceId~z${encodeURIComponent(thumb.attributes.choiceId)}~`;
    const aPosition = `xcm_pos~zPos${thumb.attributes.position}~`;
    const catIdParam = `xcm_srcCatID~z${thumb.attributes.product.relationships.taxonomy.defaultCategoryId}`;
    const isContent = thumb.attributes.content;
    const colorName = thumb.attributes.colorName ? `&swatchColor=${thumb.attributes.colorName}` : '';
    let contentParams = '';
    if (isContent) {
      // Commented to get full choiceId as per the coremetrics requirement

      // const firstSnippet = ((thumb.attributes.choiceId.split('-'))[0] || '').replace(/^cid/, '');
      // qChoiceId = `xcm_choiceId~z${encodeURIComponent(firstSnippet)}~`;

      contentParams += '~';
      const contentId = thumb.attributes.content.contentId || null;
      contentParams += (contentId) ? `xcm_contentId~z${contentId}~` : '';
      const prosSource = (thumb.attributes.content.isCollection) ? 'col' : 'con';
      contentParams += (prosSource) ? `xcm_prosSource~z${prosSource}~` : '';
    }

    return `${colorName}&tdp=${aRequester}${aZone}${qChoiceId}${aPosition}${catIdParam}${contentParams}`;
  },

  addAnalyticsInfo({
    requester, zone, pageSize, currentPage, thumbs,
  }) {
    let pos = ((currentPage - 1) * pageSize) + 1;
    return thumbs.map((thumb) => {
      const { attributes, attributes: { product: { identifier } } } = thumb;
      attributes.position = pos;
      identifier.productUrl += this.generateTdpQueryParam({
        requester, zone, thumb,
      });
      pos += 1;
      return thumb;
    });
  },

};

export default ProsTrackingHelper;
